import {DAILY_PRACTICE_LIMIT} from "../../settings/settings";
import {useNavigate} from "react-router-dom";

export default function BuyMemberShip({className, onClickBuy, ...props}) {
    const navigation = useNavigate();

    return (
        <div className={"flex flex-row justify-center px-4 pt-4 flex-wrap gap-4"}>
            <p className={"mb-4"}>
                you are not a VIP member. and your daily limit is <span
                className={"text-secondary-900"}>{DAILY_PRACTICE_LIMIT} questions per day </span>
                upgrade to VIP to get unlimited access to all questions and features.
            </p>

            <button
                onClick={() => {
                    navigation("/pricing")
                    if (onClickBuy)
                        onClickBuy()
                }}
                className={"border-[1px] rounded-md py-2 px-4 cursor-pointer bg-secondary-900 hover:bg-secondary-800 text-white"}
            >
                <p>Upgrade to VIP</p>
            </button>
        </div>

    )
}